import { Portal } from "@gorhom/portal";
import React, { forwardRef, useEffect } from "react";
import { useDragDropContext } from "../../../utilities/drag-drop";
import { PageItemType } from "../../../utilities/layout";
import { PortalHostNames } from "../../../utilities/portals";
import { View } from "react-native-ui-lib";

export type DraggableProps = {
  children: React.ReactNode;
  data: PageItemType;
  enabled?: boolean;
};

export const Draggable = forwardRef(
  ({ children, data }: DraggableProps, ref: any) => {
    const { draggingComponentRef } = useDragDropContext();

    const isDragging =
      data && draggingComponentRef.current?.data.id === data?.id;

    return isDragging ? (
      <Portal hostName={PortalHostNames.DRAG_DROP}>
        <View
          ref={ref}
          style={{
            width: draggingComponentRef.current?.startPosition.width,
            height: draggingComponentRef.current?.startPosition.height,
          }}
        >
          {children}
        </View>
      </Portal>
    ) : (
      <View ref={ref}>{children}</View>
    );
  }
);
